import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Dashboard = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '24',
    strokeAsPrimary: true,
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 24'
    >
      <path
        d='M20.5626 3H4.56256C4.01028 3 3.56256 3.44772 3.56256 4V9C3.56256 9.55228 4.01028 10 4.56256 10H20.5626C21.1148 10 21.5626 9.55228 21.5626 9V4C21.5626 3.44772 21.1148 3 20.5626 3Z'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.5626 14H4.56256C4.01028 14 3.56256 14.4477 3.56256 15V20C3.56256 20.5523 4.01028 21 4.56256 21H11.5626C12.1148 21 12.5626 20.5523 12.5626 20V15C12.5626 14.4477 12.1148 14 11.5626 14Z'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.5626 14H17.5626C17.0103 14 16.5626 14.4477 16.5626 15V20C16.5626 20.5523 17.0103 21 17.5626 21H20.5626C21.1148 21 21.5626 20.5523 21.5626 20V15C21.5626 14.4477 21.1148 14 20.5626 14Z'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
